import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';

function Layout(props) {
  return (
    <React.Fragment>

      <header>

        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
          <Container>
            <Navbar.Brand as={Link} to="/tusalud" ><span className='logo'>&nbsp;TU&nbsp;</span>SALUD</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto justify-content-end flex-grow-1 pe-3">
                <Nav.Link as={Link} to="/tusalud" >Inicio</Nav.Link>
                <Nav.Link as={Link} to="/alimentacion">Alimentación</Nav.Link>
                <Nav.Link as={Link} to="/ejercicio">Ejercicios</Nav.Link>
                <Nav.Link as={Link} to="/contacto">Contacto </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      <main>
        {props.children}

      </main>

      <footer>
        <div className='redestusalud'>
          <p className='logofooter'>Conéctate con <span className='logo'>&nbsp;TU&nbsp;</span>SALUD</p>
          <div className="socialicons">
            <a href="https://devgrimaldo.com/" target= "_blank" rel="noreferrer">
              <div className='iconwhite'>

                <div className="id social"> </div>
              </div>
            </a>

            <a href="https://devgrimaldo.com/" target= "_blank" rel="noreferrer">
              <div className='iconwhite'>

                <div className="ig social"> </div>
              </div>
            </a>

            <a href="https://devgrimaldo.com/" target= "_blank" rel="noreferrer">
              <div className='iconwhite'>

                <div className="fb social"> </div>
              </div>
            </a>

            <a href="https://devgrimaldo.com/" target= "_blank" rel="noreferrer" >
              <div className='iconwhite'>

                <div className="tw social"> </div>
              </div>
            </a>

            <a href="https://devgrimaldo.com/" target= "_blank" rel="noreferrer">
              <div className='iconwhite'>

                <div className="ws social"> </div>
              </div>
            </a>

          </div>
          
        </div>
      </footer>
    </React.Fragment>
  );
}
export default Layout;